import React from 'react'
import Dealeravailability from './dealeravailability'
import { Iprops } from './dealeravailabilityinterface'

function dealeravailabilitycontainer(props:Iprops) {

    const Action_Icons = (item: any) => {
        return(
            <td><span className='fa fa-map-marker'></span></td>
        )
    }

    const columns = [
        {
            field: 'branchlocation',
            title: "Branch Location",
            columnMenu: 'ColumnMenu',
            sortable: true,
            filterable:true
        },
        {
            field: "seeonmap",
            title: "See on Map",
            columnMenu: 'ColumnMenu',
            cell: (row: any) => <Action_Icons row={row} />,
            sortable: true,
            filterable:true
        },
        {
            field: 'quantity',
            title: "Quantity",
            sortable: true,
            filterable:true,
            columnMenu: 'ColumnMenu'
        },
    ]

    const nestedgrid = [
        {
            field: 'branchlocation',
            title: "Branch Location",
            columnMenu: 'ColumnMenu',
            sortable: true,
            filterable:true,
        },
        {
            field: "seeonmap",
            title: "See on Map",
            columnMenu: 'ColumnMenu',
            cell: (row: any) => <Action_Icons row={row} />,
            sortable: true,
            filterable:true,
        },
        {
            field: 'quantity',
            title: "Quantity",
            sortable: true,
            filterable:true,
            columnMenu: 'ColumnMenu'
        },
    ]


  return (
    <Dealeravailability columns={columns} Nestedcolumns={nestedgrid}/>
  )
}

export default dealeravailabilitycontainer